import { UPDATECATEGORYSTATUS_FAIL, UPDATECATEGORYSTATUS_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const updateCategoryStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATECATEGORYSTATUS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATECATEGORYSTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateCategoryStatusReducer;
